<template>
  <div class="challenge-container">
    <!-- 标题和介绍部分 -->
    <div class="challenge-header outbox">
			<div class="title">{{ challengeData.tasp_title }} 
        {{ formatTime(challengeData.tasp_start_time*1000,'YYYY.MM.DD') }}-{{ formatTime(challengeData.tasp_end_time*1000,'YYYY.MM.DD') }}</div>
			<div class="info-line">
				<span class="view-count">
					<i class="el-icon-view"></i>
					{{ challengeData.tasp_hits }} 
				</span>
				<span class="publish-time">{{ $t('发表于') }} {{ challengeData.update_time }}</span>
			</div>
      <div class="introduction" v-html="challengeData.tasp_content"></div>
		</div>


    <!-- 题目和答题区域 -->
    <div class="challenge-content outbox" v-if="!complete">
      <div class="challenge-questions">
        <div class="section-title">{{ $t('题目') }}</div>
        <template v-for="(question, qIndex) in questions" 
          @key="question.taspq_id">
          <QuestionItem 
            :question="question"
            :index="qIndex"
            :taspq_id="question.taspq_id"
            :taspq_type="question.taspq_type"
            :value="userAnswers[qIndex]"
            @select="handleOptionClick"
            @multiSelect="toggleMultiOption"
            @update:text="updateTextAnswer"
            @update:score="updateScoreAnswer"
          />
        </template>
        
      </div>
      
      <div class="action-bar">
        <el-button v-if="allsubmitted" type="text" class="submit-btn dis">{{ $t('提交答案') }}</el-button>
        <el-button v-else type="text" class="submit-btn" v-throttle="2000" @click="submitAnswers">{{ $t('提交答案') }}</el-button>
      </div>
    </div>
    
    <!-- 结果页面 -->
    <Result typeNum="2" :ta_id="ta_id" :tas_id="tas_id" :tasp_id="tasp_id" v-if="complete"></Result>
  </div>
</template>

<script>
import Result from './components/result.vue';
import QuestionItem from './components/QuestionItem.vue';
import VideoPlayer from './components/VideoPlayer.vue';
import { taskDetailList,taskSubmit } from '@/api/challenge';

export default {
  name: 'WeeklyChallenge',
  components: {
    Result,
    QuestionItem,
    VideoPlayer
  },
  data() {
    return {
      complete: false,
      isplay: false,
      challengeData: {
        tasp_title: '',
        update_by: '',
        tasp_hits: 0,
        publishTime: '',
        tasp_describe: '',
      },
      questions: [],
      userAnswers: [{}],
      allsubmitted: true, // 所有题目是否都已提交
      videoWatched: false,
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id; // 获取路由参数 活动id
    },
    tas_id() {
      return this.$route.params.tas_id; // 获取路由参数 阶段id
    },
    tasp_id() {
      return this.$route.params.tasp_id; // 获取路由参数 试卷id
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    handlePlayStateChanged(isPlaying) {
      this.isplay = isPlaying;
      if (!this.videoWatched && isPlaying) {
        // 可以在这里记录用户开始观看视频
      }
    },
    // 初始化获取数据
    async getData() {
      const res = await taskDetailList({
        ta_id: this.ta_id,//358
        tas_id: this.tas_id,//1
        tasp_id: this.tasp_id //15
      });
      if (res.status == 200) {
        if(res.data.status == false){
          this.$message.error(res.data.msg);
          return;
        }
        this.challengeData = res.data.paper;
        let issub = true;
        this.questions = res.data.question.map(item=>{
          if(item.is_submit!=10){
            issub = false;
          }
          if(item.taspq_type == 30){
            item.taspq_options = item.taspq_options.map(option=>{
              return {
                ...option,
                score_min: parseInt(option.score_min),
                score_max: parseInt(option.score_max),
              }
            });
          }
          return item;
        });
        this.allsubmitted = issub;
        this.initUserAnswers();
      }
    },
		initUserAnswers() {
      this.userAnswers = this.questions.map(item => {
        if(item.taspq_type==10 && item.is_submit!=10) return {
          taspq_id:item.taspq_id,
          option_title:'',
          value: ''
        };

        if(item.taspq_type == 20 && item.is_submit!=10) return [];

        if(item.taspq_type == 30 && item.is_submit!=10) return item.taspq_options.map(option=>{
          return {
            taspq_id:item.taspq_id,
            title:0,
            value:0
          }
        });

        if(item.taspq_type == 40 && item.is_submit!=10) return {
          taspq_id:item.taspq_id,
          title:'',
          value:''
        };

        if(item.is_submit==10) return item.submit_data.tasqu_value;

      });
    },
    //单选题选择
		handleOptionClick(qIndex, oIndex, option){
      let value = this.userAnswers[qIndex];
      value.option_title = option.title;
      value.value = oIndex;
			this.$set(this.userAnswers, qIndex, value);
		},
			// 多选题选择
		toggleMultiOption(qIndex, oIndex, option,taspq_id) {
      let value = this.userAnswers[qIndex];

      //判断value数组内的value字段是否和oIndex相同
      let isExist = value.some(item => item.value == oIndex);
      if(!isExist){
        value.push({
          taspq_id:taspq_id,
          option_title:option.title,
          value:oIndex
        });
      }else{
        value.map((item,index) => {
          if(item.value==oIndex){
            value.splice(index, 1);
          }
        })
      }
      this.$set(this.userAnswers, qIndex, value);
		},
    // 文本题更新
    updateTextAnswer(index, text) {
      let value = this.userAnswers[index];
      value.title = value.value = text;
      this.$set(this.userAnswers, index, value);
    },
    // 评分题选择
    updateScoreAnswer(index, oIndex, score) {
      let value = this.userAnswers[index];
      value[oIndex].title = value[oIndex].value = score;
      this.$set(this.userAnswers, index, value);
    },
    async submitAnswers() {
      let subObj = {
        ta_id: this.challengeData.ta_id,
        tas_id: this.challengeData.tas_id,
        tasp_id: this.challengeData.tasp_id,
        dd_question_type: this.challengeData.dd_question_type,
        data: JSON.parse(JSON.stringify(this.userAnswers))
      }

      // 验证是否所有必填题目都已作答
      const requiredQuestions = this.questions.filter(q => q.taspq_require);
      // 判断userAnswers数组中是否存在option_title字段,数组内还有数组的则再遍历一遍
      let isAllAnswer = true;
      for(let index = subObj.data.length-1;index>=0;index--){
        let item = subObj.data[index];
        if(this.questions[index].is_submit==10){
          subObj.data.splice(index, 1);
        }else if(Array.isArray(item)){
          item.map(item2=>{
            if((!item2.title && !item2.option_title)
              && this.questions[index].taspq_require==10
              && this.questions[index].is_submit!=10){
              isAllAnswer = false;
            }
            if((!item2.title && !item2.option_title)
              && this.questions[index].taspq_require!=10){
              subObj.data.splice(index, 1);
            }
          });
          if(item.length==0 && this.questions[index].taspq_require==10){
            isAllAnswer = false;
          }
          if(item.length==0 && this.questions[index].taspq_require!=10){
            subObj.data.splice(index, 1);
          }
        }else{
          if((!item.title && !item.option_title)
            && this.questions[index].taspq_require
            && this.questions[index].is_submit!=10){
            isAllAnswer = false;
          }
          if((!item.title && !item.option_title)
            && this.questions[index].taspq_require!=10){
            subObj.data.splice(index, 1);
          }
        }
      };
      
      if (!isAllAnswer) {
        this.$message.error(this.$t('请回答完必填题目再提交哦'));
        return;
      }
      
      const loading = this.$loading({
        lock: false,
        text: this.$t('加载中'),
        background: 'rgba(0, 0, 0, 0.1)'
      });
      const res = await taskSubmit(subObj);
      loading.close();
      if(res.status == 200){
        this.$message.success(this.$t('答题成功'));
          this.complete = true;
          this.initUserAnswers();
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }else{
        // this.$message.error(this.$t('提交失败'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.outbox{
  min-width: 1200px;
  max-width: 1680px;
  margin: 0 auto 16px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 32px;
  &:last-child{
    margin-bottom: 0;
  }
}

.challenge-container {
  width: 100%;
  padding: 80px 120px 20px;
  background: #f9f9f9;
  min-height: 100vh;
  color: #191919;
  
  .challenge-header {
    .title {
      font-size: 26px;
      line-height: 30px;
      margin-bottom: 16px;
    }
    
    .info-line {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-bottom: 15px;
      height: 22px;
      line-height: 22px;
      
      .username {
        margin-right: 20px;
      }
      
      .view-count {
        display: flex;
        align-items: center;
        margin-right: 20px;
        
        i {
          margin-right: 3px;
        }
      }
      
      .publish-time {
        color: #777777;
      }
    }
    
    .introduction {
      font-size: 14px;
      line-height: 24px;
      font-weight: 300;
      color: #595959;
    }
  }
  
  .section-title {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 24px;
    
    &.m16{
      margin-bottom: 16px;
    }
  }
  
  .action-bar {
    text-align: center;
    padding: 24px 0 32px;
    margin: 32px 0 0;
    border-top: 1px dashed rgb(230, 230, 230);
    
    .submit-btn {
      box-sizing: border-box;
      font-size: 14px;
      border: 1px solid rgb(179, 0, 0);
      border-radius: 20px;
      min-width: 86px;
      padding: 12px;
      background: rgb(255, 255, 255);
      color: #B30000;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        background-color: rgba(179, 0, 0, 0.1);
      }
      &.dis {
        color: #999999;
        border-color: #999999;
        cursor: not-allowed;
        &:hover { 
          background-color: transparent; 
        }
      }
    }
  }
}
</style>